import {Injectable} from '@angular/core';

import {HttpClient} from '@angular/common/http';
import {IncomeTaxRange} from './resource/income-tax-range';
import {BaseService} from '../../core/service/base.service';

@Injectable()
export class IncomeTaxRangeService extends BaseService<IncomeTaxRange> {

  serviceUrl(): string {
    return `/api/income-tax-ranges`;
  }

  constructor(protected http: HttpClient) {
    super(http);
  }
}
